import mountApp     from 'cfg/mountApp';
import RegisterForm from './Vue/RegisterForm.vue';


export default (selector, options = {})=> {
  const vueOptions = {
    translationDomain: 'register',
    components: { RegisterForm },
    data() {
      return {
        role          : options.role          || 'advertiser',
        recaptchaKey  : options.recaptchaKey  || '',
        mondiadApiUrl : options.mondiadApiUrl || '',
      };
    },
  };

  return mountApp({...options, ...vueOptions}, selector);
};
